/**
 * TanStack Query hooks for `campaign-browser-targeting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignBrowserTargetingQueryKeys,
	type CreateCampaignBrowserTargetingBody,
	type ListCampaignBrowserTargetingResponse,
	type CampaignBrowserTargetingRow,
} from "./api";

export function useCampaignBrowserTargetingList(): UseQueryResult<ListCampaignBrowserTargetingResponse, Error> {
	return useQuery({
		queryKey: campaignBrowserTargetingQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignBrowserTargetingCreate(): UseMutationResult<CampaignBrowserTargetingRow, Error, CreateCampaignBrowserTargetingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignBrowserTargetingQueryKeys.all });
		},
	});
}

export function useCampaignBrowserTargetingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignBrowserTargetingQueryKeys.all });
		},
	});
}
